// extracted by mini-css-extract-plugin
export default {"root":"_1pFIC","cover":"_3ynr7","middle":"_3brr8","underlay":"_WYHX"};